<template>
  <el-dialog
      :model-value="modelValue"
      :title="isEdit ? 'Hodisani tahrirlash' : 'Yangi hodisa'"
      width="640px"
      align-center
      destroy-on-close
      @update:model-value="$emit('update:modelValue', $event)"
  >
    <!-- Katakda qanday ko'rinishi -->
    <div class="fc-preview">
      <span class="fc-preview__title">{{ previewCell }}</span>
      <span class="fc-preview__badge" :style="badgeStyle">{{ dayLabelText }}</span>
      <span v-if="!form.is_active" class="fc-preview__off">Nofaol</span>
    </div>

    <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="Ma'lumot turi (qator)" prop="dataset_id">
            <el-select v-model="form.dataset_id" filterable placeholder="Tanlang" style="width: 100%">
              <el-option
                  v-for="d in datasets"
                  :key="d.id"
                  :label="datasetTitle(d)"
                  :value="d.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Davriylik" prop="periodicity_id">
            <el-select v-model="form.periodicity_id" placeholder="Tanlang" style="width: 100%">
              <el-option
                  v-for="p in periodicities"
                  :key="p.id"
                  :label="periodicityTitle(p)"
                  :value="p.id"
              >
                <span class="fc-opt">
                  <span class="fc-opt__dot" :style="{background: p.color}"/>
                  {{ periodicityTitle(p) }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="Yil" prop="year">
            <el-input-number
                v-model="form.year"
                :min="yearMin"
                :max="yearMax"
                controls-position="right"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Oy" prop="month">
            <el-select v-model="form.month" placeholder="Oy" style="width: 100%">
              <el-option v-for="m in 12" :key="m" :label="monthLabel(m)" :value="m"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Boshlanish kuni" prop="day_from">
            <el-input-number
                v-model="form.day_from"
                :min="1"
                :max="31"
                controls-position="right"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-alert v-if="dayError" type="error" :closable="false" show-icon class="fc-alert">
        {{ dayError }}
      </el-alert>

      <el-form-item label="Tugash kuni (ixtiyoriy)" prop="day_to">
        <el-input-number
            v-model="form.day_to"
            :min="1"
            :max="31"
            controls-position="right"
            placeholder="—"
            style="width: 200px"
        />
        <el-button v-if="form.day_to" link type="primary" @click="form.day_to = null">
          Tozalash
        </el-button>
        <div class="fc-hint">
          Faqat diapazon uchun («Kunlik daromad/xarajat»: 1 dan 31 gacha).
          Bo'sh qoldirilsa bitta kun ko'rsatiladi. Bu <b>ko'rsatiladigan</b> tugash kuni,
          real sana emas — shuning uchun fevralda ham 31 yozish mumkin.
        </div>
      </el-form-item>

      <div class="fc-label">
        Hisobot davri <span class="fc-label__hint">(badge ostida va modalda ko'rinadi)</span>
      </div>
      <el-tabs v-model="activeReportLang" class="fc-lang-tabs">
        <el-tab-pane v-for="lt in langTabs" :key="lt.code" :name="lt.code">
          <template #label>
            <span class="fc-lang-tab">
              {{ lt.tabLabel }}
              <span class="fc-lang-tab__dot" :class="{'is-filled': !!form.report_period[lt.code]}"/>
            </span>
          </template>
          <el-input
              v-model="form.report_period[lt.code]"
              :placeholder="reportPlaceholder(lt.code)"
              clearable
          />
        </el-tab-pane>
      </el-tabs>

      <div class="fc-label">Izoh <span class="fc-label__hint">(faqat modalda ko'rinadi)</span></div>
      <el-tabs v-model="activeNoteLang" class="fc-lang-tabs">
        <el-tab-pane v-for="lt in langTabs" :key="lt.code" :name="lt.code">
          <template #label>
            <span class="fc-lang-tab">
              {{ lt.tabLabel }}
              <span class="fc-lang-tab__dot" :class="{'is-filled': !!form.note[lt.code]}"/>
            </span>
          </template>
          <el-input
              v-model="form.note[lt.code]"
              type="textarea"
              :rows="3"
              :placeholder="'Izoh — ' + langLabels[lt.code]"
          />
        </el-tab-pane>
      </el-tabs>

      <el-form-item label="Havola (ixtiyoriy)" prop="link_url">
        <el-input v-model="form.link_url" placeholder="Bo'sh qoldirilsa qator havolasi ishlatiladi" clearable/>
      </el-form-item>

      <el-row :gutter="16">
        <el-col :span="12">
          <div class="fc-label">Tartib raqami</div>
          <el-input-number v-model="form.order_number" controls-position="right" style="width: 100%"/>
          <div class="fc-hint">Bitta katakda bir nechta badge bo'lsa — ularning tartibi.</div>
        </el-col>
        <el-col :span="12">
          <div class="fc-label">Holati</div>
          <el-switch
              v-model="form.is_active"
              inline-prompt
              active-text="Faol"
              inactive-text="Nofaol"
              style="--el-switch-on-color: #16A34A"
          />
          <div class="fc-hint">Nofaol badge portalda ko'rinmaydi.</div>
        </el-col>
      </el-row>
    </el-form>

    <template #footer>
      <el-button
          v-if="isEdit"
          type="danger"
          plain
          :loading="deleting"
          class="fc-footer-left"
          @click="onDelete"
      >O'chirish</el-button>
      <el-button plain :disabled="submitting" @click="$emit('update:modelValue', false)">
        Bekor qilish
      </el-button>
      <el-button type="primary" :loading="submitting" @click="onSubmit">
        {{ isEdit ? "Saqlash" : "Qo'shish" }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";
import api, {
  LANG_TABS,
  LANG_LABELS,
  emptyMultiLang,
  fillMultiLang,
  displayLangText,
  monthName,
  lastDayOfMonth,
  dayLabel,
  contrastTextColor,
  apiErrorMessage,
  YEAR_MIN,
  YEAR_MAX,
} from "./psdsCalendarApi";

export default {
  name: "PsdsEventDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    // null = yaratish, aks holda tahrirlanayotgan hodisa (to'liq ob'ekt).
    event: { type: Object, default: null },
    datasets: { type: Array, default: () => [] },
    periodicities: { type: Array, default: () => [] },
    // Gridda katak bosilganda oldindan to'ldiriladigan qiymatlar.
    defaults: { type: Object, default: () => ({}) },
  },
  emits: ["update:modelValue", "saved"],
  data() {
    return {
      submitting: false,
      deleting: false,
      activeReportLang: "uz_lat",
      activeNoteLang: "uz_lat",
      langTabs: LANG_TABS,
      langLabels: LANG_LABELS,
      yearMin: YEAR_MIN,
      yearMax: YEAR_MAX,
      form: this.buildForm(null, {}),
      rules: {
        dataset_id: [{ required: true, message: "Qatorni tanlang", trigger: "change" }],
        periodicity_id: [{ required: true, message: "Davriylikni tanlang", trigger: "change" }],
        year: [{ required: true, message: "Yilni kiriting", trigger: "blur" }],
        month: [{ required: true, message: "Oyni tanlang", trigger: "change" }],
        day_from: [{ required: true, message: "Kunni kiriting", trigger: "blur" }],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.event;
    },
    selectedPeriodicity() {
      return this.periodicities.find((p) => p.id === this.form.periodicity_id) || null;
    },
    badgeStyle() {
      const color = this.selectedPeriodicity?.color || "#94A3B8";
      return { background: color, color: contrastTextColor(color) };
    },
    dayLabelText() {
      return dayLabel(this.form.day_from, this.form.day_to) || "—";
    },
    previewCell() {
      const dataset = this.datasets.find((d) => d.id === this.form.dataset_id);
      const title = dataset ? displayLangText(dataset.title) : "Qator tanlanmagan";
      return `${title} — ${monthName(this.form.month)} ${this.form.year}`;
    },
    // Backend `day_from` ni oyga nisbatan tekshiradi; shu tekshiruvni oldindan
    // ko'rsatib, keraksiz so'rovning oldini olamiz (JAVOBLAR.md B7).
    dayError() {
      const { year, month, day_from: dayFrom, day_to: dayTo } = this.form;
      if (dayFrom && month && year) {
        const last = lastDayOfMonth(year, month);
        if (dayFrom > last) {
          return `${monthName(month)} ${year} da ${dayFrom}-kun yo'q — oyning oxirgi kuni ${last}.`;
        }
      }
      if (dayTo && dayFrom && dayTo < dayFrom) {
        return "Tugash kuni boshlanish kunidan kichik bo'lmasligi kerak.";
      }
      return "";
    },
  },
  watch: {
    modelValue(val) {
      if (!val) return;
      this.activeReportLang = "uz_lat";
      this.activeNoteLang = "uz_lat";
      this.form = this.buildForm(this.event, this.defaults);
    },
  },
  methods: {
    buildForm(event, defaults) {
      const now = new Date();
      return {
        dataset_id: event?.dataset_id ?? defaults.dataset_id ?? null,
        periodicity_id: event?.periodicity_id ?? defaults.periodicity_id ?? null,
        year: event?.year ?? defaults.year ?? now.getFullYear(),
        month: event?.month ?? defaults.month ?? now.getMonth() + 1,
        day_from: event?.day_from ?? null,
        day_to: event?.day_to ?? null,
        report_period: event ? fillMultiLang(event.report_period) : emptyMultiLang(),
        note: event ? fillMultiLang(event.note) : emptyMultiLang(),
        link_url: event?.link_url || "",
        order_number: event?.order_number ?? 0,
        is_active: event ? event.is_active !== false : true,
      };
    },
    datasetTitle(dataset) {
      const title = displayLangText(dataset.title) || `#${dataset.id}`;
      return dataset.is_active === false ? `${title} (nofaol)` : title;
    },
    periodicityTitle(periodicity) {
      const title = displayLangText(periodicity.title) || periodicity.code;
      return periodicity.is_active === false ? `${title} (nofaol)` : title;
    },
    monthLabel(month) {
      return monthName(month);
    },
    reportPlaceholder(code) {
      if (code === "uz_lat") return "Masalan: Dekabr oyi uchun (2025 yil)";
      return `Hisobot davri — ${LANG_LABELS[code]}`;
    },
    onSubmit() {
      if (this.dayError) {
        ElMessage.error(this.dayError);
        return;
      }
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          ElMessage.error("Iltimos, majburiy maydonlarni to'ldiring");
          return;
        }
        // PUT to'liq almashtirish — hamma maydon yuboriladi. `day_to` bo'sh
        // bo'lsa `null` (0 yuborilsa backend 400 qaytaradi — JAVOBLAR.md A4).
        const payload = {
          dataset_id: this.form.dataset_id,
          periodicity_id: this.form.periodicity_id,
          year: Number(this.form.year),
          month: Number(this.form.month),
          day_from: Number(this.form.day_from),
          day_to: this.form.day_to ? Number(this.form.day_to) : null,
          report_period: { ...this.form.report_period },
          note: { ...this.form.note },
          link_url: this.form.link_url.trim(),
          order_number: Number(this.form.order_number) || 0,
          is_active: this.form.is_active,
        };
        this.submitting = true;
        const request = this.isEdit
            ? api.updateEvent(this.event.id, payload)
            : api.createEvent(payload);
        request
            .then(() => {
              ElMessage({
                type: "success",
                message: this.isEdit ? "Hodisa yangilandi" : "Hodisa qo'shildi",
              });
              this.$emit("update:modelValue", false);
              // Yil dialogda o'zgargan bo'lishi mumkin — grid qaysi yilni
              // qayta yuklashni bilsin.
              this.$emit("saved", payload.year);
            })
            .catch((error) => {
              ElNotification.error({
                title: "Saqlashda xatolik",
                message: apiErrorMessage(error),
                duration: 6000,
              });
            })
            .finally(() => {
              this.submitting = false;
            });
      });
    },
    onDelete() {
      ElMessageBox.confirm(
          "Hodisani o'chirasizmi? Admin paneldan qaytarib bo'lmaydi.",
          "Hodisani o'chirish",
          { confirmButtonText: "Ha, o'chirish", cancelButtonText: "Bekor qilish", type: "warning" }
      )
          .then(() => {
            this.deleting = true;
            return api.deleteEvent(this.event.id).then(() => {
              ElMessage({ type: "success", message: "Hodisa o'chirildi" });
              this.$emit("update:modelValue", false);
              this.$emit("saved");
            });
          })
          .catch((error) => {
            if (error?.response) {
              ElNotification.error({ title: "O'chirib bo'lmadi", message: apiErrorMessage(error) });
            }
          })
          .finally(() => {
            this.deleting = false;
          });
    },
  },
};
</script>

<style scoped lang="scss">
@use "./psds-calendar.scss";

.fc-opt {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
  }
}

.fc-footer-left {
  float: left;
}
</style>
